import {Box, Grid, Typography} from "@mui/material";
import {textStyle, title} from "../../styles/TabStyles";
import React, {useEffect, useRef, useState} from "react";
import {useLanguage} from "../../../LanguageContext";
import FullScreenTab from "./FullScreenTab";
import {Swiper, SwiperSlide} from "swiper/react";
import {Autoplay} from "swiper/modules";

import gal1 from "../../../images/tours/gallery/gal1.JPG";
import gal2 from "../../../images/tours/gallery/gal2.JPG";
import gal3 from "../../../images/tours/gallery/gal3.JPG";
import gal4 from "../../../images/tours/gallery/gal4.JPG";
import gal5 from "../../../images/tours/gallery/gal5.JPG";
import gal6 from "../../../images/tours/gallery/gal6.JPG";
import gal7 from "../../../images/tours/gallery/gal7.JPG";
import gal8 from "../../../images/tours/gallery/gal8.PNG";
import gal9 from "../../../images/tours/gallery/gal9.PNG";
import gal10 from "../../../images/tours/gallery/gal10.PNG";
import gal11 from "../../../images/tours/gallery/gal11.PNG";


const images = [
    gal1,
    gal2,
    gal3,
    gal4,
    gal5,
    gal6,
    gal7,
    gal8,
    gal9,
    gal10,
    gal11,
];
export const EssentialsTab = ({context}) => {
    const {t} = useLanguage();

    const swiperContainerRef = useRef(null);
    const [swiperHeight, setSwiperHeight] = useState(0);

    useEffect(() => {
        if (swiperContainerRef.current) {
            setSwiperHeight(swiperContainerRef.current.clientHeight);
        }
        // Resize listener for dynamic height updates
        const handleResize = () => {
            if (swiperContainerRef.current) {
                setSwiperHeight(swiperContainerRef.current.clientHeight);
            }
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);


    return (
        <FullScreenTab>
            <Grid
                container
                justifyContent="center"
                height={"100%"}
                alignItems="stretch">
                {/* First Item */}
                <Grid item xs={12} md={8} sm={8} lg={8}>
                    <Box
                        ref={swiperContainerRef} // Reference this Box
                        sx={{
                            display: "flex",
                            // alignItems: "center",
                            justifyContent: "center",
                            textAlign: 'center',
                            p: 5,
                            height: "100%",
                            minHeight: {
                                xs: '0',
                                md: "600px"
                            },
                        }}
                    >
                        <Box
                            sx={{
                                p: {
                                    xs: 2,
                                    md: 0.
                                }
                            }}>
                            <Typography sx={title}>
                                {t('label_travel_essentials')}
                            </Typography>

                            <Box
                                sx={{
                                    width: {
                                        xs: '100%',
                                        md: '80%',
                                    },
                                    ml: {
                                        xs: '0%',
                                        md: '10%',
                                    },
                                    textAlign: 'left',
                                }}
                            >
                                {t(context.items).map((item, index) => (
                                    <Box key={index}>
                                        <Typography sx={textStyle}>
                                            {item}
                                        </Typography>
                                    </Box>
                                ))}
                            </Box>
                        </Box>

                    </Box>
                </Grid>

                {/* Second Item */}
                <Grid item xs={12} md={4} sm={4} lg={4}
                      sx={{
                          display: {
                              xs: 'none',
                              sm: 'none',
                              md: 'flex',
                              xl: 'flex',
                          },
                          p: 0,
                          height: "100%",
                          alignItems: "stretch"
                      }}>
                    <Box
                        sx={{
                            width: "100%",
                            p: 0,
                            height: '100%',
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            textAlign: 'center',
                            pt: {
                                md: '0px',
                            },
                        }}
                    >
                        <Swiper
                            modules={[Autoplay]}
                            spaceBetween={40}
                            slidesPerView={'auto'}
                            direction={'vertical'}
                            loop={true}
                            autoplay={{delay: 3000}}
                            style={{
                                borderRadius: "0px",
                                overflow: "hidden",
                                height: `${swiperHeight}px`,
                            }}
                        >
                            {images.map((item, index) => (
                                <SwiperSlide key={index} style={{height: "300px"}}>  {/* Set explicit height */}
                                    <Box sx={{position: "relative", height: "100%"}}>
                                        <Box
                                            component="img"
                                            src={item}
                                            alt={`Slide ${index + 1}`}
                                            sx={{
                                                width: "100%",
                                                height: "100%",
                                                objectFit: "cover",
                                                borderRadius: "0px",
                                            }}
                                        />
                                    </Box>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </Box>
                </Grid>
            </Grid>


        </FullScreenTab>
    );
}
